<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <div v-if="!loaded" class="text-center my-4">
      <div class="custom-loader"></div>
      <p class="loading-text">Lettura dei permessi in corso...</p>
    </div>
    <div v-else class="broker-visibility">
      <label class="broker-visibility__title">Visibilità produttori</label>
      <div class="broker-visibility__row">
        <span
          class="broker-visibility__side"
          :class="{ 'is-active': !isSpecific }"
        >
          Globale
        </span>
        <b-form-checkbox
          v-model="isSpecific"
          name="broker-visibility"
          switch
          :disabled="noBrokers"
        >
          <span
            class="broker-visibility__side"
            :class="{ 'is-active': isSpecific }"
          >
            Specifica
          </span>
        </b-form-checkbox>
      </div>
      <p v-if="noBrokers" class="broker-visibility__hint">
        <b-icon icon="exclamation-triangle" scale="1.00"></b-icon>
        Nessun produttore da mostrare: la visibilità di questo utente non è
        modificabile da qui.
      </p>
      <p v-else-if="!isSpecific" class="broker-visibility__hint">
        <b-icon icon="info-circle" scale="1.00"></b-icon>
        L'utente vede tutti i produttori.
      </p>
    </div>
    <div class="actions-toolbar">
      <div
        class="d-flex justify-content-end"
        style="gap: 10px"
        v-if="isSpecific"
      >
        <b-button
          :pressed.sync="readAll"
          variant="lisaweb"
          class="mr-1"
          @click="toggleAllPermissions('read')"
        >{{ readAll ? "Deseleziona" : "Seleziona" }} tutti: Lettura
        </b-button
        >
        <b-button
          :pressed.sync="writeAll"
          variant="lisaweb"
          @click="toggleAllPermissions('write')"
        >{{ writeAll ? "Deseleziona" : "Seleziona" }} tutti:
          Modifica
        </b-button
        >
      </div>
    </div>
    <salesmen
      v-show="loaded && isSpecific"
      :fields="fields"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      :filterOn="{
        byRelations: [/* 'byCorrespondence', 'byAddressBook',  */ 'byUser'],
      }"
      noActions
      noPagination
      :ref="tableRef"
    ></salesmen>
    <div class="form-actions form-actions--sticky">
      <div class="inner-wrapper ml-3">
        <div>
          <span
            :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
          >
          <b-button
            type="button"
            variant="lisaweb"
            size="sm"
            title="Salva Permessi"
            :disabled="isSaving"
            @click="onPermissions"
          >
            <b-spinner small type="grow" v-show="isSaving"></b-spinner>
            Salva Permessi
          </b-button>
          </span>
        </div>
        <div>
          <b-button
            @click="$router.back()"
            class="btn--transparent"
            type="button"
            title="Torna alla pagina precedente"
          >
            <b-icon-chevron-double-left
              font-scale="0.9"
            ></b-icon-chevron-double-left
            >
            Torna indietro
          </b-button
          >
        </div>
      </div>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
import Salesmen from "@/components/tables/Salesmen.vue";
import {mapActions} from "vuex";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";
import {computed} from "vue";

export default {
  mixins: [CustomFiltersMixin, ConfirmModalMixin, DetailTabAutofetchTableMixin],
  data() {
    return {
      repository: "broker",
      resource: "brokers",
      tableRef: "SalesmenPermissionTableRef",
      filterName: "filterSalesmenPermission",
      user: this.$route.params.user,
      args: {},
      /* la prima fetch decide lo stato: prima di allora non si mostra nulla */
      loaded: false,
      /* elenco vuoto: lo stato del pivot non e' deducibile, e non si puo' salvare */
      noBrokers: false,
      isSaving: false,
      isSpecific: false,
      /* lo stato persistito all'ultimo fetch: decide se la conferma serve */
      hadRows: false,
      readAll: false,
      writeAll: false,
      filter: this.initFilter(),
      fields: [
        {
          key: "attributables.BUID",
          label: this.getDictionary("attribute_BUID_value", "broker"),
          sortable: true,
          sortKey: "BUID",
        },
        {
          key: "attributables.SURN",
          label: this.getDictionary("attribute_SURN_value", "broker"),
          sortable: true,
          sortKey: "SURN",
        },
        {
          key: "attributables.NAME",
          label: this.getDictionary("attribute_NAME_value", "broker"),
          sortable: true,
          sortKey: "NAME",
        },
        {
          key: "attributables.CNAM",
          label: this.getDictionary("attribute_CNAM_value", "broker"),
          sortable: true,
          sortKey: "CNAM",
        },
        {
          key: "read",
          label: this.getDictionary("read", "broker"),
        },
        {
          key: "write",
          label: this.getDictionary("write", "broker"),
        },
      ],
    };
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      args: computed(() => this.args),
    };
  },
  components: {
    Salesmen,
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          status_broker: 0,
          title: null,
          NAME: null,
          SURN: null,
          BUID: null,
        },
      };
      return init;
    },
    onPermissions() {
      if (this.noBrokers) {
        this.$showSnackbar({
          preset: "error",
          text: "Nessun produttore da mostrare: la visibilità non può essere salvata.",
        });
        return;
      }
      if (this.isSpecific) {
        this.storePermissions();
        return;
      }
      /* Visibilità globale == nessuna riga nel pivot: salvare vuol dire cancellarle */
      if (!this.hadRows) {
        this.destroyPermissions();
        return;
      }
      this.showConfirm({
        title: "Rimuovere le limitazioni?",
        message:
          "Vengono rimosse tutte le limitazioni su visualizzazione e modifica dei produttori: da questo momento l'utente potrà vedere e modificare tutti i produttori, compresi quelli che verranno creati in futuro.",
        yesCallback: () => {
          this.destroyPermissions();
        },
      });
    },
    storePermissions() {
      const payload = {
        broker: {},
      };

      this.$refs[this.tableRef].items.forEach((item) => {
        payload.broker[item.id] = {
          read: item.read ? "Y" : "N",
          write: item.write ? "Y" : "N",
        };
      });

      this.isSaving = true;
      this.addBrokerPermission(this.user.id, this.repository, payload)
        .then(() => {
          this.$showSnackbar({
            preset: "info",
            text: "Permessi Aggiornati",
          });

          return this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    destroyPermissions() {
      /* payload "sbiancato": il detach vuole solo le chiavi, come in reports */
      const payload = {
        broker: {},
      };

      this.$refs[this.tableRef].items.forEach((item) => {
        payload.broker[item.id] = {};
      });

      this.isSaving = true;
      this.deleteBrokerPermission(this.user.id, this.repository, payload)
        .then(() => {
          this.$showSnackbar({
            preset: "info",
            text: "Permessi Aggiornati",
          });

          return this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    addBrokerPermission(id, relation, payload) {
      const Repo = RepositoryFactory.get("user");
      return Repo.pivot_store(id, relation, payload);
    },
    deleteBrokerPermission(id, relation, payload) {
      const Repo = RepositoryFactory.get("user");
      return Repo.pivot_destroy(id, relation, payload);
    },
    setPermission(item, type) {
      if (!item.users?.length) {
        return false;
      }
      const found = item.users.find((e) => e.id === this.user.id);
      if (found) {
        return found.pivot[type].value === "Y" ? true : false;
      }
      return false;
    },
    hasPermissionRow(item) {
      return !!item.users?.some((e) => e.id === this.user.id);
    },
    setPermissions(data) {
      data.forEach((e) => {
        e["read"] = this.setPermission(e, "read");
        e["write"] = this.setPermission(e, "write");
      });
      /* Un elenco vuoto non dice nulla sul pivot: non va letto come "globale".
         Succede quando chi compila la pagina ha lui stesso limitazioni sui
         produttori, perché GET /brokers è filtrato sulla sua visibilità. */
      this.noBrokers = !data.length;
      if (!this.noBrokers) {
        /* Nessuna riga nel pivot == visibilità globale, come in
           HasBrokerAllowable::getAllowableBrokers() lato backend */
        this.hadRows = data.some((e) => this.hasPermissionRow(e));
        this.isSpecific = this.hadRows;
      }
      this.loaded = true;
      this.readAll = !data.some((e) => e.read === false);
      this.writeAll = !data.some((e) => e.write === false);
      return data;
    },
    // selectAllPermissions(type) {
    //   this.$refs[this.tableRef].items.forEach((item) => {
    //     this.$set(item, type, type === "read" ? !this.readAll : !this.writeAll);
    //   });
    //   if (type === "read") {
    //     this.readAll = !this.readAll;
    //   }
    //   if (type === "write") {
    //     this.writeAll = !this.writeAll;
    //   }
    // },
    toggleAllPermissions(type) {
      this.$refs[this.tableRef].items.forEach((item) => {
        this.$set(item, type, type === "read" ? this.readAll : this.writeAll);
      });
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", {removePaginationByName: "removeByName"}),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
  mounted() {
    /* La fetch iniziale la lancia template.vue, quindi qui non se ne ha la
       promise: lo stato "letto" si aggancia alla fine del caricamento della
       tabella, così vale anche quando la chiamata fallisce (l'errore lo
       segnala già la snackbar del template) e il loader non resta acceso per
       sempre. Se al mount non c'è nessuna fetch in corso non c'è nulla da
       attendere. */
    const table = this.$refs[this.tableRef];
    if (!table.isLoading) {
      this.loaded = true;

      return;
    }
    this.$watch(
      () => table.isLoading,
      (loading) => {
        if (!loading) {
          this.loaded = true;
        }
      }
    );
  },
  created() {
    let criteria = this.filter;
    let name = this.filterName;
    this.saveFilterByName({name, criteria});
    /* L'elenco arriva da brokers-assignable e non da index: qui i produttori
       vanno mostrati tutti, non solo quelli che chi compila la pagina vede.
       alias: 'index' tiene il controllo permessi del template su
       resources.brokers.index. */
    this.args = {
      items: {handle: this.setPermissions},
      verb: {name: "assignable", alias: "index"},
    };
  },
};
</script>

<style lang="scss" scoped>
.broker-visibility {
  margin-bottom: 1rem;

  &__title {
    display: block;
    font-weight: 500;
    margin-bottom: 0.35rem;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  &__side {
    color: #6c757d;
    transition: color 0.2s ease;

    &.is-active {
      color: var(--lisaweb);
      font-weight: 600;
    }
  }

  &__hint {
    margin: 0.5rem 0 0;
    color: #6c757d;
  }

  /*
   * Interruttore stile iOS: pillola con pomello bianco tondo.
   * Il colore acceso non si scrive qui: lo impone già la regola globale
   * `input[type=checkbox]:checked + label:before { background: var(--lisaweb) !important }`
   * di custom.scss, che segue anche il tema riassegnato a runtime da utils/theme.js.
   */
  :deep(.custom-switch) {
    padding-left: 2.75rem;
    min-height: 1.625rem;

    .custom-control-label {
      /* custom.scss mette padding-top: 5px su .custom-control-label: sposta il
         testo ma non gli pseudo-elementi, quindi qui va azzerato */
      padding-top: 0;
      padding-left: 0.35rem;
      line-height: 1.625rem;
      cursor: pointer;

      &::before {
        left: -2.75rem;
        top: 0;
        width: 2.75rem;
        height: 1.625rem;
        border-radius: 1rem;
        background-color: var(--gray-100);
        border-color: var(--gray-100);
        transition: background-color 0.2s ease, border-color 0.2s ease;
      }

      &::after {
        left: calc(-2.75rem + 2px);
        top: 2px;
        width: 1.375rem;
        height: 1.375rem;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
        transition: transform 0.2s ease;
      }
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(1.125rem);
      background-color: #fff;
    }
  }
}
</style>
